import { render } from "./OurEquipmentSmallScreen.vue?vue&type=template&id=25ec9840"
import script from "./OurEquipmentSmallScreen.vue?vue&type=script&lang=js"
export * from "./OurEquipmentSmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__